<template>
    <div class="home">
        <div class="wrp">
            <div class="tool-bar">
                <div class="search">
                    <el-input placeholder="请输入应用名称" class="search-input" prefix-icon="el-icon-search" v-model="keyword"></el-input>
                </div>
            </div>
            <div class="app-list">
                <div class="app-item" @click="$router.push('/release')">
                    <el-card shadow="always" class="app-card add-app">
                        <i class="icon el-icon-plus"></i>
                    </el-card>
                </div>
                <div v-for="item in getAppData" :key="item.id" class="app-item">
                    <el-card shadow="always" class="app-card">
                        <div class="app-logo">
                            <img :src="item.icon_url" alt="">
                        </div>
                        <div class="app-name">{{ item.app_name }}</div>
                        <div class="app-tool">
                            <el-tooltip class="item" effect="dark" content="下载" placement="top">
                                <el-button type="primary" icon="el-icon-full-screen" circle @click="goDownload(item.id)"></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="版本列表" placement="top">
                                <el-button type="warning" icon="el-icon-tickets" circle @click="handleAppCommand('versionList', item)" style="margin-left: 0;"></el-button>
                            </el-tooltip>
                            <el-dropdown trigger="click" @command="(command) => handleAppCommand(command, item)">
                                <el-tooltip class="item" effect="dark" content="更多" placement="top">
                                    <el-button type="info" icon="el-icon-setting" circle></el-button>
                                </el-tooltip>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item command="release">发布新版本</el-dropdown-item>
                                        <el-dropdown-item command="hotUpdate">热更新</el-dropdown-item>
                                        <el-dropdown-item command="appEdit">编辑</el-dropdown-item>
                                        <el-dropdown-item command="appDel">删除</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    data() {
        return {
            appList: [],
            keyword: ''
        }
    },
    mounted() {
        this.getAppList();
    },
    methods: {
        async getAppList() {
            const res = await this.$api.applicationList();
            if(res.data.code == 0) {
                let _list = res.data.data.list
                _list.forEach((res)=>{
                    if(!res.app_name){
                        res.app_name = '未设置'
                    }
                })
                this.appList = res.data.data.list;
            }
        },
        handleAppCommand(command, row) {
            if(command === 'appDel') {
                this.delApp(row.id);
            } else {
                this.$store.commit('setPageTitle', row.app_name);
                localStorage.setItem('pageTitle', row.app_name);
                this.$router.push({
                    name: command,
                    query: {
                        id: row.id
                    }
                });
            }
        },
        goDownload(id) {
            let routeUrl = this.$router.resolve({
                path: "/download",
                query: {
                    id
                }
            });
            window.open(routeUrl.href, '_blank');
        },
        delApp(id) { // 删除app
            this.$confirm('此操作将永久删除该app, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const loading = this.$loading({
                    lock: true,
                    text: '正在删除',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const res = await this.$api.appDel({
                    id
                });
                if(res.data.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    loading.close();
                    this.getAppList();
                }
            }).catch(() => {});
        }
    },
    computed: {
        getAppData() {
            return this.appList.filter(item => item.app_name.indexOf(this.keyword) > -1);
        }
    }
}
</script>

<style lang="scss" scoped>
    .wrp {
        width: 90%;
        margin: 0 auto;
        padding-top: 20px;
    }

    .tool-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .app-list {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        margin-left: -10px;
        margin-right: -10px;

        .app-item {
            margin-bottom: 20px;
            width: 293px;
            height: 350px;
            padding: 0 10px;

            .app-card {
                height: 100%;
            }

            .app-logo {
                width: 70%;
                margin: 0 auto;

                img {
                    display: block;
                    width: 100%;
                }
            }

            .app-name {
                text-align: center;
                font-weight: 700;
                padding-top: 30px;
                padding-bottom: 20px;
                font-size: 22px;
            }

            .app-tool {
                border-top: 1px solid #eee;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 20px 40px 0;
            }

            .add-app {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                .icon {
                    font-size: 120px;
                    color: #ccc;
                }
            }
        }
    }

    @media (max-width: 414px) {
        .app-list {
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
</style>
